"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotURLFilters = getNotURLFilters;
exports.normalizeAudience = normalizeAudience;
exports.serializeAudience = serializeAudience;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _filterUtils = require("AudienceTargetingUIComponents/utils/filterUtils");

var _createUUID = _interopRequireDefault(require("AudienceTargetingUIComponents/utils/createUUID"));

function getNotURLFilters(values) {
  return values.filter(function (filter) {
    var vals = (0, _filterUtils.getOrValues)(filter);
    return vals.getIn([0, 'type']) !== 'URL' && vals.getIn([0, 'type']) !== 'QUERY_PARAM';
  });
}

function setInitialFilterIfEmpty(audience) {
  var newAudience = Object.assign({}, audience);

  if (audience === null || !audience.filter || !audience.filter.type) {
    return {
      filter: (0, _filterUtils.getInitialFilter)()
    };
  } else if (!getNotURLFilters(audience.filter.values).length) {
    newAudience.filter.values.push((0, _filterUtils.getDefaultBlankFilter)((0, _createUUID.default)()));
  } else if (!(0, _filterUtils.hasUrlFilter)(audience.filter)) {
    newAudience.filter.values.push((0, _filterUtils.getDefaultUrlGroupFilter)());
  }

  return newAudience;
}

function setNullIfPristine(payload) {
  if (!payload || !payload.filter.values.length) return null;
  return payload;
}

function removeEmptyGroups(payload) {
  var filter = payload.filter;
  var normalizedFilter = (0, _immutable.fromJS)(filter);
  var newValues = normalizedFilter.get('values').filter(function (group) {
    var values = (0, _filterUtils.getOrValues)(group);
    var withValues = values.filter(function (f) {
      if (f.get('values') && (f.get('values').length || f.get('values').size)) {
        return Boolean(f.get('values').length || f.get('values').size);
      }

      return Boolean(f.get('values') || !f.get('values') && typeof f.get('values') === 'boolean');
    });
    return Boolean(withValues.size);
  });
  newValues = newValues.map(function (group) {
    var values = (0, _filterUtils.getOrValues)(group);
    var filteredValues = values.filter(function (f) {
      return Boolean(f.get('values') || !f.get('values') && typeof f.get('values') === 'boolean');
    });
    var path = group.get('operator') === 'NOT' ? ['values', 0, 'values'] : ['values'];
    return group.setIn(path, filteredValues);
  });
  var newFilter = normalizedFilter.set('values', newValues);
  var normalizedFilters = newFilter.toJS();
  var newAudienceDefinition = {
    filter: normalizedFilters,
    name: null
  };
  return newAudienceDefinition;
} // before sending to the api


function normalizeAudience(payload) {
  var newPayload = removeEmptyGroups(payload);
  newPayload = setNullIfPristine(newPayload);
  return newPayload;
} // after loading from the api


function serializeAudience(payload) {
  var newPayload = (0, _extends2.default)({}, payload);
  return setInitialFilterIfEmpty(newPayload);
}